import { ExternalServiceType, MerchantCashAdvance, SyndicationDetailsDto } from '../graphql/types';

export function latestExternalConnectionByType(
  data: MerchantCashAdvance | SyndicationDetailsDto,
  preferredTypes: ExternalServiceType[]
): any | undefined {
  const connections = data?.externalConnections || [];

  const sorted = connections
    .filter((c) => c.isActive && c.externalServiceConfiguration?.createdAt)
    .sort(
      (a, b) => new Date(b.externalServiceConfiguration.createdAt).getTime() - new Date(a.externalServiceConfiguration.createdAt).getTime()
    );

  const latestByType = sorted.reduce((map, conn) => {
    const type = conn.externalServiceConfiguration?.type || 'unknown';
    if (!map.has(type)) {
      map.set(type, conn);
    }
    return map;
  }, new Map<string, any>());

  return preferredTypes.map((type) => latestByType.get(type)).find(Boolean) || [...latestByType.values()][0];
}
